var _path, _line, _path2, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScreens(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8077 2.44231V13.9808C10.8077 14.3633 10.9597 14.7301 11.2302 15.0006C11.5007 15.2711 11.8675 15.4231 12.25 15.4231H29.5577C29.9403 15.4231 30.3071 15.2711 30.5776 15.0006C30.8481 14.7301 31 14.3633 31 13.9808V2.44231C31 2.05978 30.8481 1.69293 30.5776 1.42244C30.3071 1.15196 29.9403 1 29.5577 1H12.25C11.8675 1 11.5007 1.15196 11.2302 1.42244C10.9597 1.69293 10.8077 2.05978 10.8077 2.44231Z",
    fill: "white",
    stroke: "#B0C0C6"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 18.8846,
    y1: 14.1192,
    x2: 22.9231,
    y2: 14.1192,
    stroke: "#B0C0C6",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.48078V18.0192C1 18.4018 1.15196 18.7686 1.42244 19.0391C1.69293 19.3096 2.05978 19.4615 2.44231 19.4615H19.75C20.1325 19.4615 20.4994 19.3096 20.7699 19.0391C21.0404 18.7686 21.1923 18.4018 21.1923 18.0192V6.48078C21.1923 6.09825 21.0404 5.73139 20.7699 5.46091C20.4994 5.19042 20.1325 5.03847 19.75 5.03847H2.44231C2.05978 5.03847 1.69293 5.19042 1.42244 5.46091C1.15196 5.73139 1 6.09825 1 6.48078Z",
    fill: "white",
    stroke: "#B0C0C6"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 9.0769,
    y1: 18.1577,
    x2: 13.1154,
    y2: 18.1577,
    stroke: "#B0C0C6",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreens);
export default __webpack_public_path__ + "static/media/screens.7948eab1.svg";
export { ForwardRef as ReactComponent };